// extracted by mini-css-extract-plugin
export default {"notification":"styles_notification__w67nC","supplier":"styles_supplier__gtUYg","status":"styles_status__lwW4l","message":"styles_message__ywkLC"};